// import { useMemo } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import { 
  // Box, 
  useMediaQuery 
} from '@mui/material';

// project import
// import Search from './Search';
// import Message from './Message';
import Profile from './Profile';
import Notification from './Notification';
import { 
  // Greeter, 
  HotelDateAndLicense 
} from './HeaderComponents';
// import MobileSection from './MobileSection';
// import MegaMenuSection from './MegaMenuSection';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';

// types
import { MenuOrientation } from 'types/config';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation } = useConfig();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  // const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      <HotelDateAndLicense />
      <>
        <Notification />
        <Profile />
      </>
      {/* {downLG && <MobileSection />} */}
    </>
  );
};

export default HeaderContent;
